<template>
  <b-modal
    modal-class="client-form-modal"
    body-class="bg-extra-light-gray p-0"
    footer-class="bg-extra-light-gray"
    v-model="editorShown"
    :title="form ? form.name : ''"
    @ok="submitClient"
    size="md-lg"
    centered
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <template v-slot:modal-header>
      <div
        class="w-100 d-flex flex-row justify-content-between align-items-center"
      >
        <h5 class="modal-title">
          {{
            eocId
              ? "Edit Patient"
              : patientId
              ? "Existing Patient"
              : "New Patient"
          }}
        </h5>
        <div class="d-flex align-items-center">
          <button
            type="button"
            aria-label="Close"
            class="close text-white"
            @click="cancelAddEdit"
          >
            ×
          </button>
        </div>
      </div>
    </template>

    <template v-slot:modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <div class="text-left mt-1 mr-2">
          <b-button
            v-if="eocId"
            class="ml-2"
            variant="danger"
            @click="removeEOC"
            >Delete Episode of Care</b-button
          >
        </div>
        <div class="text-right mt-1 mr-2">
          <b-button @click="cancelAddEdit" variant="secondary">Cancel</b-button>
          <b-button
            ref="submitButton"
            class="ml-2"
            variant="primary"
            @click="submitClient"
            >Save</b-button
          >
          <b-button
            class="ml-2"
            ref="submitAndCloseButton"
            variant="primary"
            @click="submitClientAndCloseTab"
            >Save and Close</b-button
          >
        </div>
      </div>
    </template>

    <div class="position-relative">
      <div class="d-flex">
        <div class="client-form-container position-relative w-100 bg-white">
          <b-tabs v-model="activeTab">
            <b-tab title="Patient Info">
              <div class="bg-extra-light-gray section-title rounded">
                <h6 class="mb-0">
                  Demographics
                </h6>
                <div>
                  <b-button
                    v-if="!this.patientId && this.showButtonDuplicateUser"
                    @click="showDuplicateAlert"
                    block
                    variant="warning"
                    >Possible client duplication</b-button
                  >
                </div>
              </div>
              <div class="section-body">
                <image-cropper
                  :image="fileChoosed"
                  v-model="cropImage"
                  @cropped="saveCroppedImage"
                  @cancel="revertCrop"
                />
                <b-row>
                  <b-col class="mb-3 mt-1">
                    <div
                      class="d-flex flex-row justify-content-start align-items-center h-100 mb-0 border rounded-lg"
                    >
                      <div
                        class="d-flex flex-row justify-content-start align-items-center"
                      >
                        <div
                          class="picture-preview ml-5 mr-2"
                          style="width: 152px; height: 152px;"
                        >
                          <img
                            :src="
                              avatar
                                ? avatar
                                : require(`../../assets/avatar-example.png`)
                            "
                          />
                        </div>
                        <b-form-group
                          :state="avatarErrors.length == 0 ? null : false"
                          :invalid-feedback="avatarErrors.join(', ')"
                        >
                          <input
                            ref="fileUpload"
                            @change="cropFile"
                            type="file"
                            accept="image/*"
                            hidden
                          />
                        </b-form-group>
                        <div class="d-flex flex-column ml-5">
                          <label
                            class="m-2 text-primary choose-picture"
                            @click="chooseFile()"
                            ><i class="fa fa-upload m-1"></i> Upload
                            Picture</label
                          >
                          <label
                            class="m-2 text-primary choose-picture"
                            @click="showPictureTaker()"
                            ><i class="fa fa-camera m-1"></i> Take
                            Picture</label
                          >
                          <label
                            v-if="avatar"
                            class="m-2 text-red choose-picture"
                            @click="removePicture()"
                            ><i class="fa fa-trash m-1"></i> Remove
                            Picture</label
                          >
                        </div>
                      </div>
                    </div>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="First Name"
                      :state="formErrors.firstName.length == 0 ? null : false"
                      :invalid-feedback="formErrors.firstName.join(', ')"
                    >
                      <template v-slot:label>
                        First Name <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        v-model="form.firstName"
                        trim
                        maxLength="100"
                        :state="formErrors.firstName.length == 0 ? null : false"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Middle Name">
                      <b-form-input
                        v-model="form.middleName"
                        trim
                        maxLength="100"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group label="Preferred Name">
                      <b-form-input
                        v-model="form.preferredName"
                        trim
                        maxLength="100"
                      ></b-form-input>
                    </b-form-group>
                    <b-form-group
                      label="Last Name"
                      :state="formErrors.lastName.length == 0 ? null : false"
                      :invalid-feedback="formErrors.lastName.join(', ')"
                    >
                      <template v-slot:label>
                        Last Name <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        v-model="form.lastName"
                        trim
                        maxLength="100"
                        :state="formErrors.lastName.length == 0 ? null : false"
                        @blur="handleBlur"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="DOB"
                      :state="formErrors.dateOfBirth.length == 0 ? null : false"
                      :invalid-feedback="formErrors.dateOfBirth.join(', ')"
                      @blur="handleBlur"
                    >
                      <template v-slot:label>
                        DOB <span class="text-danger">*</span>
                      </template>
                      <date-picker
                        v-model="form.dateOfBirth"
                        :errors="formErrors.dateOfBirth"
                        @handleBlur="handleBlur"
                      ></date-picker>
                    </b-form-group> </b-col
                  ><b-col>
                    <b-form-group
                      label="MR#"
                      :state="formErrors.mrn.length == 0 ? null : false"
                      :invalid-feedback="formErrors.mrn.join(', ')"
                    >
                      <template v-slot:label>
                        MR# <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        v-model="form.mrn"
                        trim
                        maxLength="30"
                        :state="formErrors.mrn.length == 0 ? null : false"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="SSN"
                      v-if="hasCurrentUserPermissionAccess('patients', 'ssn')"
                      :state="formErrors.ssn.length == 0 ? null : false"
                      :invalid-feedback="formErrors.ssn.join(', ')"
                    >
                      <b-form-input
                        v-model="form.ssn"
                        v-facade="'###-##-####'"
                        trim
                        :state="formErrors.ssn.length == 0 ? null : false"
                        @blur="handleBlur"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Legal Sex"
                      :state="formErrors.gender.length == 0 ? null : false"
                      :invalid-feedback="formErrors.gender.join(', ')"
                    >
                      <template v-slot:label>
                        Legal Sex
                        <span
                          v-if="
                            isDoseSpotActive || systemSetting.saisystemsEnabled
                          "
                          class="text-danger"
                          >*</span
                        >
                      </template>
                      <v-select
                        v-model="form.gender"
                        :options="genders"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="Mobile Phone number"
                      :state="formErrors.phone.length == 0 ? null : false"
                      :invalid-feedback="formErrors.phone.join(', ')"
                    >
                      <template v-slot:label>
                        Mobile Phone number
                        <span v-if="isDoseSpotActive || isEMAREnabled" class="text-danger"
                          >*</span
                        >
                      </template>
                      <phone-input
                        ref="phoneInput"
                        defaultCountry="US"
                        v-model="form.phone"
                        trim
                        :state="formErrors.phone.length == 0 ? null : false"
                        @handleBlur="handleBlur"
                      ></phone-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Other Phone number"
                      :state="
                        formErrors.landLineNumber.length == 0 ? null : false
                      "
                      :invalid-feedback="formErrors.landLineNumber.join(', ')"
                    >
                      <phone-input
                        ref="landPhoneInput"
                        defaultCountry="US"
                        v-model="form.landLineNumber"
                        trim
                        :state="
                          formErrors.landLineNumber.length == 0 ? null : false
                        "
                        @handleBlur="handleBlur"
                      ></phone-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group label="Patient prefers to be contacted by">
                      <b-form-radio-group v-model="form.contactPreference">
                        <b-form-radio
                          v-for="(option, index) in contactPreferences"
                          :key="index"
                          :value="index"
                          class="mr-4"
                          >{{ option }}
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="Email"
                      :state="formErrors.email.length == 0 ? null : false"
                      :invalid-feedback="formErrors.email.join(', ')"
                    >
                      <template v-slot:label>
                        Email
                        <span v-if="isDoseSpotActive || isEMAREnabled" class="text-danger"
                          >*</span
                        >
                      </template>
                      <b-form-input
                        v-model="form.email"
                        trim
                        maxLength="150"
                        :state="formErrors.email.length == 0 ? null : false"
                        @blur="handleBlur"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="Address Line 1"
                      :state="
                        formErrors.addressLine1.length == 0 ? null : false
                      "
                      :invalid-feedback="formErrors.addressLine1.join(', ')"
                    >
                      <template v-slot:label>
                        Address Line 1   
                        <span v-if="isDoseSpotActive || isEMAREnabled" class="text-danger"
                          >*</span
                        >
                      </template>
                      <b-form-input
                        v-model="form.addressLine1"
                        trim
                        maxLength="150"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Address Line 2">
                      <b-form-input
                        v-model="form.addressLine2"
                        trim
                        maxLength="150"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="City"
                      :state="formErrors.city.length == 0 ? null : false"
                      :invalid-feedback="formErrors.city.join(', ')"
                    >
                      <template v-slot:label>
                        City
                        <span v-if="isDoseSpotActive || isEMAREnabled" class="text-danger"
                          >*</span
                        >
                      </template>
                      <b-form-input
                        v-model="form.city"
                        trim
                        maxLength="100"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      label="State"
                      :state="formErrors.state.length == 0 ? null : false"
                      :invalid-feedback="formErrors.state.join(', ')"
                    >
                      <template v-slot:label>
                        State
                        <span v-if="isDoseSpotActive || isEMAREnabled" class="text-danger"
                          >*</span
                        >
                      </template>
                      <v-select
                        v-model="form.state"
                        :options="states"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group
                      label="Zip Code"
                      :state="formErrors.zipcode.length == 0 ? null : false"
                      :invalid-feedback="formErrors.zipcode.join(', ')"
                    >
                      <template v-slot:label>
                        Zip Code
                        <span v-if="isDoseSpotActive || isEMAREnabled" class="text-danger"
                          >*</span
                        >
                      </template>
                      <b-form-input
                        v-model="form.zipcode"
                        v-facade="'#####'"
                        trim
                        :state="formErrors.zipcode.length == 0 ? null : false"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group label="Marital Status">
                      <v-select
                        v-model="form.maritalStatus"
                        :options="maritalStatuses"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Race">
                      <v-select v-model="form.race" :options="races" />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group label="Occupation">
                      <b-form-input
                        v-model="form.occupation"
                        trim
                        maxLength="100"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Ethnicity">
                      <v-select
                        v-model="form.ethnicity"
                        :options="ethnicities"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group label="Language">
                      <v-select v-model="form.language" :options="languages" />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Preferred Pronoun">
                      <template v-slot:label>
                        Preferred Pronouns
                      </template>
                      <v-select
                        v-model="form.pronoun"
                        :options="pronouns"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group label="Places of service">
                      <template v-slot:label>
                        Places of service
                      </template>
                      <multiple-select
                        v-model="form.placesOfService"
                        :options="placesOfService"
                        :sortFn="
                          (a, b) => a.data.name.localeCompare(b.data.name)
                        "
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="General Notes">
                      <b-form-textarea
                        v-model="form.generalNotes"
                        rows="4"
                      ></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="bg-extra-light-gray rounded section-title">
                <h6 class="mb-0">Episode of care</h6>
              </div>
              <div class="section-body">
                <b-row>
                  <b-col>
                    <b-form-group
                      label="Start/Admission Date"
                      :state="formErrors.startDate.length == 0 ? null : false"
                      :invalid-feedback="formErrors.startDate.join(', ')"
                    >
                      <date-time-picker
                        v-model="form.startDate"
                        :errors="formErrors.startDate"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group
                      v-if="form.endDate"
                      label="End Date"
                      :state="formErrors.endDate.length == 0 ? null : false"
                      :invalid-feedback="formErrors.endDate.join(', ')"
                    >
                      <date-time-picker
                        v-model="form.endDate"
                        :errors="formErrors.endDate"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group
                      label="Mrn Suffix"
                      :state="formErrors.eocn.length == 0 ? null : false"
                      :invalid-feedback="formErrors.eocn.join(', ')"
                    >
                      <b-form-input
                        v-model="form.eocn"
                        trim
                        :state="formErrors.eocn.length == 0 ? null : false"
                        :formatter="formatMrnSuffix"
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col >
                    <b-form-group v-if="!systemSetting.hideReferralSourcesFromPatientDemographics" label="Referral Source">
                      <b-form-input
                        v-model="form.referralSource"
                        trim
                      ></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group label="Primary Provider">
                      <v-select
                        v-model="primaryProviderForm"
                        :options="providerUsers"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="bg-extra-light-gray rounded section-title">
                <h6 class="mb-0">Additional Information</h6>
              </div>
              <div class="px-2 section-body">
                <div class="text-center" v-if="formAdditionalInfo">
                  <div class="builder w-100">
                    <fb-form-viewer
                      :json="json.layout"
                      v-if="
                        json &&
                          json.layout &&
                          json.layout.rows &&
                          json.layout.rows.length > 0
                      "
                      showType="form-submitter"
                    ></fb-form-viewer>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Insurance">
              <b-form-radio-group v-model="form.billType">
                <b-form-radio
                  v-for="(option, index) in billTypes"
                  :key="index"
                  :value="index"
                  class="mr-5"
                  >{{ option }}
                </b-form-radio>
              </b-form-radio-group>

              <div class="bg-extra-light-gray rounded section-title">
                <h6 class="mb-0">Insurances</h6>
                <b-button
                  :disabled="form.billType != 1"
                  variant="primary"
                  size="sm"
                  @click="addInsurance"
                  ><i class="fa fa-plus"></i
                ></b-button>
              </div>
              <div class="section-body">
                <b-row>
                  <b-col>
                    <div v-if="insuranceItems.length > 0">
                      <data-card
                        :cardInfo="insurance"
                        v-for="insurance in insuranceItems"
                        :key="insurance.itemIndex"
                        @edit-item="editInsurance(insurance)"
                        @delete-item="deleteInsurance(insurance)"
                        :disable="form.billType != 1"
                      />
                    </div>
                    <div
                      v-else
                      class="d-flex justify-content-center color-custom-grey"
                    >
                      No insurance information.
                    </div>
                    <insurance-form
                      :insurance="formInsurance"
                      v-if="insuranceModalShow"
                      v-model="insuranceModalShow"
                      @ok="submitInsurance"
                      @onModify="insuranceModalShow = false"
                    />
                  </b-col>
                </b-row>
              </div>
            </b-tab>

            <b-tab title="Payment Methods">
              <div class="bg-extra-light-gray rounded section-title">
                <h6 class="mb-0">Payment Methods</h6>
                <b-button variant="primary" size="sm" @click="addPaymentMethod"
                  ><i class="fa fa-plus"></i
                ></b-button>
              </div>
              <div class="section-body">
                <b-row>
                  <b-col cols="6">
                    <patient-payment-methods
                      ref="patientPaymentMethod"
                      class="m-2"
                      :patientId="this.patientId"
                      :noSelectable="true"
                      :isDemographics="true"
                      @setPatientPaymentMethods="setPatientPaymentMethods"
                    ></patient-payment-methods>
                  </b-col>
                </b-row>
              </div>
            </b-tab>

            <b-tab title="Allergies">
              <div class="bg-extra-light-gray rounded section-title">
                <h6 class="mb-0">Allergies</h6>
                <b-button variant="primary" size="sm" @click="addAllergy"
                  ><i class="fa fa-plus"></i
                ></b-button>
              </div>
              <div class="section-body">
                <b-row>
                  <b-col>
                    <div v-if="allergyItems.length > 0">
                      <data-card
                        :cardInfo="allergy"
                        v-for="(allergy, allergyIndex) in allergyItems"
                        :key="allergyIndex"
                        @edit-item="editAllergy(allergy)"
                        @delete-item="deleteAllergy(allergy)"
                      />
                    </div>
                    <div
                      v-else
                      class="d-flex justify-content-center color-custom-grey"
                    >
                      No allergy information.
                    </div>
                    <allergy-form
                      v-if="allergyModalShow"
                      v-model="allergyModalShow"
                      @onModify="onModifyAddAllergy"
                      @ok="submitAllergy"
                      :allergy="formAllergy"
                    ></allergy-form>
                  </b-col>
                </b-row>
              </div>
            </b-tab>

            <eoc-portal-contacts
              :patientId="patientId"
              :contacts.sync="form.contacts"
              :patientEmail="form.email"
            />

            <eoc-portal-guarantors
              :patientId="patientId"
              :guarantors.sync="form.guarantors"
              :patientInfo="this.getPatientInfo()"
            />

            <b-tab title="Assigned Personnel">
              <div class="bg-extra-light-gray rounded section-title">
                <h6 class="mb-0">Case Load</h6>
                <b-button variant="primary" size="sm" @click="addCaseLoad">
                  <i class="fa fa-plus"></i>
                </b-button>
              </div>
              <div class="section-body">
                <b-row>
                  <b-col>
                    <div v-if="caseLoadItems.length > 0">
                      <data-card
                        :cardInfo="caseLoad"
                        v-for="(caseLoad, caseLoadIndex) in caseLoadItems"
                        :key="caseLoadIndex"
                        @edit-item="editCaseLoad(caseLoad)"
                        @delete-item="deleteCaseLoad(caseLoad)"
                      />
                    </div>
                    <div
                      v-else
                      class="d-flex justify-content-center color-custom-grey"
                    >
                      No case load information.
                    </div>
                    <b-modal
                      centered
                      v-model="caseLoadModalShow"
                      :title="
                        formCaseLoadId ? 'Edit Case Load' : 'Add Case Load'
                      "
                      header-bg-variant="primary"
                      header-text-variant="white"
                      @ok="submitCaseLoad"
                      no-close-on-backdrop
                      header-class="bg-purple"
                    >
                      <template v-slot:modal-footer="{ ok, cancel }">
                        <b-button
                          class="bg-med-light-gray"
                          variant="light"
                          @click="cancel()"
                        >
                          Cancel
                        </b-button>
                        <b-button variant="primary" @click="ok()">
                          Save
                        </b-button>
                      </template>
                      <b-form-group
                        label="Case Role*"
                        :state="
                          formCaseLoadErrors.caseRole.length == 0 ? null : false
                        "
                        :invalid-feedback="
                          formCaseLoadErrors.caseRole.join(', ')
                        "
                      >
                        <v-select
                          v-model="formCaseLoad.caseRole"
                          :options="caseRoles"
                        ></v-select>
                      </b-form-group>
                      <b-form-group
                        label="User*"
                        :state="
                          formCaseLoadErrors.user.length == 0 ? null : false
                        "
                        :invalid-feedback="formCaseLoadErrors.user.join(', ')"
                      >
                        <v-select
                          v-model="formCaseLoad.user"
                          :options="
                            formCaseLoad.caseRole &&
                            formCaseLoad.caseRole.data.type == 'PrimaryProvider'
                              ? providerUsers
                              : users
                          "
                        ></v-select>
                      </b-form-group>
                    </b-modal>
                  </b-col>
                </b-row>
              </div>
            </b-tab>

            <eoc-portal-access
              ref="portalAccess"
              :patientId="patientId"
              :values.sync="portalAccesses"
              :patient.sync="patientItem"
              :contacts.sync="form.contacts"
            />
          </b-tabs>
        </div>
      </div>
    </div>
    <b-modal
      v-model="pictureTakerShown"
      title="Picture"
      @ok="savePicture"
      centered
      size="md"
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="white"
      header-class="bg-purple"
      @hidden="stopAccessCamera"
    >
      <template v-slot:modal-ok="{}">Take Picture</template>
      <template v-slot:modal-cancel="{}">Cancel</template>
      <div class="text-center">
        <video ref="video" id="video" width="460" height="250" autoplay></video>
        <canvas
          v-show="false"
          ref="canvas"
          id="canvas"
          width="460"
          height="250"
        ></canvas>
      </div>
    </b-modal>
    <eoc-possible-duplications
      v-if="this.showDialogDuplicateUser"
      v-model="this.showDialogDuplicateUser"
      :possibleUsersDuplicates="this.possibleUsersDuplicates"
      @cancel="cancel"
      @addUser="setPatient"
    />
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";

import eocServer from "../../server/eoc";
import patientServer from "../../server/patient";
import avatarServer from "../../server/avatar";
import serverCore from "../../server/core";
import userServer from "../../server/user";
import {
  formatDateTimeSql,
  formatDateTimeMysql,
  formatDateOnly
} from "../../helpers/date";
import {
  validatePhoneNumber,
  validateSSN,
  validateZipcode,
  validateRequired,
  validateEmail,
  validateDate
} from "../../helpers/validation";
import { fileToBase64, resizeImage } from "../../helpers/file";
import DatePicker from "../controls/DatePicker";
import DateTimePicker from "../controls/DateTimePicker.vue";
import ImageCropper from "../controls/ImageCropper";
import DataCard from "../controls/DataCard";
import InsuranceForm from "./PatientInsuranceForm";
import {
  getElementComponentData,
  getElementFromId
} from "../../../../Breeze.FormBuilder.Frontend/helpers/formBuilder";
import { randomId } from "../../helpers/general";
import AllergyForm from "./PatientAllegyForm";
import { formatUser } from "../../helpers/user";
import EocPortalAccess from "./edit_patient/EocPortalAccess.vue";
import EocPortalContacts from "./edit_patient/EocPortalContacts.vue";
import EocPortalGuarantors from "./edit_patient/EocPortalGuarantors.vue";
import PhoneInput from "../controls/PhoneInput.vue";

import eligibilityVerificationServer from "../../server/eligibilityVerification";
import insuranceCompanyServer from "../../server/insuranceCompany";
import { hasClass } from "../../helpers/layout";
import EocPossibleDuplications from "./EocPossibleDuplications.vue";

import PatientPaymentMethods from "./PatientPaymentMethods.vue";
import MultipleSelect from "../controls/MultipleSelect.vue";

export default {
  name: "EocAddEditModal",
  components: {
    DatePicker,
    ImageCropper,
    DataCard,
    DateTimePicker,
    InsuranceForm,
    AllergyForm,
    EocPortalAccess,
    EocPortalContacts,
    EocPortalGuarantors,
    PhoneInput,
    EocPossibleDuplications,
    PatientPaymentMethods,
    MultipleSelect
  },
  props: [
    "eocId",
    "clientId",
    "initialTab",
    "eligibilityVerificationId",
    "locationId"
  ],
  data() {
    return {
      pictureTakerShown: false,
      eocEditId: this.eocId,
      patientId: this.clientId,

      form: {
        firstName: null,
        middleName: null,
        preferredName: null,
        lastName: null,
        dateOfBirth: null,
        email: "",
        phone: "",
        landLineNumber: "",
        ssn: "",
        gender: null,
        pronoun: null,
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: null,
        zipcode: "",
        insurances: [],
        contacts: [],
        guarantors: [],
        allergies: [],
        startDate: "",
        endDate: null,
        mrn: "",
        eocn: "",
        referralSource: "",
        caseLoads: [],
        primaryProvider: null,
        maritalStatus: null,
        race: null,
        ethnicity: null,
        language: null,
        occupation: "",
        billType: 0,
        contactPreference: 0,
        paymentMethods: [],
        generalNotes: "",
        placesOfService: []
      },
      formErrors: {
        firstName: [],
        lastName: [],
        dateOfBirth: [],
        email: [],
        phone: [],
        landLineNumber: [],
        ssn: [],
        zipcode: [],
        startDate: [],
        endDate: [],
        mrn: [],
        eocn: [],
        gender: [],
        pronoun: [],
        addressLine1: [],
        city: [],
        state: []
      },
      fileChoosed: null,
      cropImage: false,
      removedPicture: false,
      avatar: null,
      avatarErrors: [],
      insuranceModalShow: false,
      formInsurance: null,
      contactModalShow: false,
      formContact: null,
      guarantorModalShow: false,
      formGuarantor: null,
      allergyModalShow: false,
      formAllergy: null,
      caseLoadModalShow: false,
      formCaseLoadId: null,
      formCaseLoad: {
        user: null,
        caseRole: null
      },
      formCaseLoadErrors: {
        user: [],
        caseRole: []
      },
      users: [],
      portalAccesses: [],
      formAdditionalInfo: {},
      additionalsResults: {},
      additionalsReportResults: {},
      activeTab: 0,
      hasUnsavedChanges: false,
      dataLoaded: false,
      billTypes: ["Self-Pay", "Insurance"],
      insuranceCoverages: ["Primary", "Secondary", "Other", "Tertiary"],
      contactPreferences: ["Mobile Phone", "Other Phone", "Both"],
      possibleUsersDuplicates: [],
      showDialogDuplicateUser: false,
      alreadyShownAlert: false,
      showButtonDuplicateUser: false,
      clientSaved: false,
      nextMrn: 0,
      stream: null,
      paymentMethodsModified: false
    };
  },
  async mounted() {
    this.activeTab = this.initialTab ?? 0;
    this.initialize();
  },
  methods: {
    ...mapMutations("client", ["dispatchListener"]),
    ...mapActions("layout", ["showAlertSuccess", "showError"]),
    ...mapActions("client", ["fetchCaseRoles"]),
    ...mapMutations("formSubmitter", ["setInitialValues"]),
    ...mapActions("formSubmitter", [
      "validateFormSubmitterForm",
      "initializeFormSubmitterForm"
    ]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    formatMrnSuffix(e) {
      return String(e).substring(0, 2);
    },
    async handleBlur() {
      if (!this.patientId) {
        const fields = [
          this.form.lastName,
          this.form.dateOfBirth,
          this.form.ssn,
          this.form.phone.replace(this.form.phone.slice(0, 2), ""),
          this.form.landLineNumber.replace(
            this.form.landLineNumber.slice(0, 2),
            ""
          ),
          this.form.email
        ];
        let isCombination = fields
          .filter(x => x != "")
          .filter(x => x != null)
          .filter(x => x != this.activePhoneCountry.dialCode)
          .filter(x => x != this.activeLandLineNumberCountry.dialCode);
        if (isCombination.length >= 2) {
          await patientServer
            .findPosibleDuplications(
              {
                lastName: this.form.lastName,
                dateOfBirth: this.form.dateOfBirth,
                ssn: this.form.ssn,
                phone: this.form.phone,
                landLineNumber: this.form.landLineNumber,
                CountryCode: "+" + this.activePhoneCountry.dialCode,
                landLineNumberCountryCode:
                  "+" + this.activeLandLineNumberCountry.dialCode,
                email: this.form.email
              },
              { "Hide-Loading": true }
            )
            .then(result => {
              if (result.length > 0) {
                this.possibleUsersDuplicates = result;
                if (!this.alreadyShownAlert) {
                  this.showDialogDuplicateUser = true;
                  this.alreadyShownAlert = true;
                } else {
                  this.showButtonDuplicateUser = true;
                }
              } else {
                this.showButtonDuplicateUser = false;
              }
            });
        } else {
          if (this.showButtonDuplicateUser) {
            this.showButtonDuplicateUser = false;
          }
        }
      }
    },
    setPatient(userId) {
      this.patientId = userId;
      this.initializeClientForm();
      this.showDialogDuplicateUser = false;
    },
    showDuplicateAlert() {
      this.showDialogDuplicateUser = true;
    },
    cancel() {
      this.showDialogDuplicateUser = false;
      this.showButtonDuplicateUser = true;
    },
    async initialize() {
      await this.fetchFormBuilderForms({ category: "eocAdditionalInfo" });
      await this.initializeClientForm();
      await this.initializeFormSubmitter();
      this.getUsers();
      this.fetchCaseRoles();
      this.dataLoaded = true;
    },
    async initializeClientForm() {
      this.paymentMethodsModified = false;
      let nextEocId = "";
      let patient = null;
      if (!this.patientId) this.nextMrn = await patientServer.getNextMrn();
      else {
        patient = await patientServer.get(this.patientId);
        this.nextMrn = patient.lastEoc ? patient.lastEoc.mrn : "";
        nextEocId = await eocServer.getNextEocId(this.patientId);
      }
      if (this.eocEditId) {
        const eoc = await eocServer.get(this.eocEditId);
        const ssn = await patientServer.getSSN(eoc.patient.id);
        const primaryProvider = eoc.caseLoads.find(
          cL => cL.caseRole && cL.caseRole.type == "PrimaryProvider"
        );
        let insurances = [];
        for (let i = 0; i < eoc.patient.insurances.length; i++) {
          let insurance = eoc.patient.insurances[i];
          insurances.push({
            ...insurance,
            relationship: insurance.patientRelationship,
            coverage: insurance.insuranceCoverage,
            effectiveDateStart: insurance.effectiveDateFrom,
            effectiveDateEnd: insurance.effectiveDateTo,
            coInsurance: insurance.coInsurancePercent,
            gracePeriod: insurance.gracePeriod
              ? {
                  value: insurance.gracePeriod,
                  name: "Yes"
                }
              : {
                  value: insurance.gracePeriod,
                  name: "No"
                },
            insuranceCardFrontBase64: insurance.insuranceCardFrontId
              ? await this.downloadImage(insurance.insuranceCardFrontId)
              : null,
            insuranceCardBackBase64: insurance.insuranceCardBackId
              ? await this.downloadImage(insurance.insuranceCardBackId)
              : null,
            insuranceCardFrontUrl: insurance.insuranceCardFrontId
              ? await this.downloadFullImage(insurance.insuranceCardFrontId)
              : null,
            insuranceCardBackUrl: insurance.insuranceCardBackId
              ? await this.downloadFullImage(insurance.insuranceCardBackId)
              : null
          });
        }
        this.form = {
          firstName: eoc.patient.firstName,
          middleName: eoc.patient.middleName,
          preferredName: eoc.patient.preferredName,
          lastName: eoc.patient.lastName,
          dateOfBirth: eoc.patient.dateOfBirth,
          email: eoc.patient.email,
          phone: eoc.patient.phone,
          landLineNumber: eoc.patient.landLineNumber,
          ssn: ssn,
          gender: eoc.patient.gender
            ? {
                value: eoc.patient.gender.id,
                label: eoc.patient.gender.name
              }
            : null,
          pronoun: eoc.patient.pronoun
            ? {
                value: eoc.patient.pronoun.id,
                label: eoc.patient.pronoun.name
              }
            : null,
          addressLine1: eoc.patient.addressLine1,
          addressLine2: eoc.patient.addressLine2,
          city: eoc.patient.city,
          state: eoc.patient.state
            ? {
                value: eoc.patient.state.id,
                label: eoc.patient.state.name
              }
            : null,
          zipcode: eoc.patient.zipcode,
          insurances: insurances,
          contacts: eoc.patient.contacts,
          guarantors: eoc.patient.guarantors,
          allergies: eoc.patient.allergies,
          caseLoads: eoc.caseLoads ? eoc.caseLoads : [],
          startDate: eoc.startDate ? formatDateTimeMysql(eoc.startDate) : "",
          endDate: eoc.endDate ? formatDateTimeMysql(eoc.endDate) : null,
          mrn: eoc.patient.mrn,
          eocn: eoc.eocn,
          referralSource: eoc.referralSource,
          additionalsResults: eoc.additionalsResults,
          additionalsReportResults: eoc.additionalsReportResults,
          primaryProvider: primaryProvider
            ? {
                value: primaryProvider.user.id,
                label: formatUser(primaryProvider.user)
              }
            : null,
          maritalStatus: eoc.patient.maritalStatus
            ? {
                value: eoc.patient.maritalStatus.id,
                label: eoc.patient.maritalStatus.name
              }
            : null,
          race: eoc.patient.race
            ? {
                value: eoc.patient.race.id,
                label: eoc.patient.race.name
              }
            : null,
          ethnicity: eoc.patient.ethnicity
            ? {
                value: eoc.patient.ethnicity.id,
                label: eoc.patient.ethnicity.name
              }
            : null,
          language: eoc.patient.language
            ? {
                value: eoc.patient.language.id,
                label: eoc.patient.language.name
              }
            : null,
          occupation: eoc.patient.occupation,
          billType: eoc.patient.billType,
          generalNotes: eoc.patient.generalNotes,
          contactPreference:
            eoc.patient.contactPreference == "Cellphone"
              ? 0
              : eoc.patient.contactPreference == "Landline"
              ? 1
              : 2,
          placesOfService: eoc.placesOfService.map(place => ({
            value: place.id,
            label: place.code + "-" + place.name,
            data: place
          }))
        };
        if (eoc.patient.avatarId) {
          this.avatar = await this.downloadImage(eoc.patient.avatarId);
        }
      } else if (this.patientId) {
        const ssn = await patientServer.getSSN(this.patientId);
        this.form = {
          firstName: patient.firstName,
          middleName: patient.middleName,
          preferredName: patient.preferredName,
          lastName: patient.lastName,
          dateOfBirth: patient.dateOfBirth,
          email: patient.email,
          phone: patient.phone,
          landLineNumber: patient.landLineNumber,
          ssn: ssn,
          gender: patient.gender
            ? {
                value: patient.gender.id,
                label: patient.gender.name
              }
            : null,
          pronoun: patient.pronoun
            ? {
                value: patient.pronoun.id,
                label: patient.pronoun.name
              }
            : null,
          addressLine1: patient.addressLine1,
          addressLine2: patient.addressLine2,
          city: patient.city,
          state: patient.state
            ? {
                value: patient.state.id,
                label: patient.state.name
              }
            : null,
          zipcode: patient.zipcode,
          insurances: patient.insurances.map(insurance => ({
            ...insurance,
            relationship: insurance.patientRelationship
          })),
          avatar: patient.avatar,
          contacts: patient.contacts,
          guarantors: patient.guarantors,
          allergies: patient.allergies,
          caseLoads: [],
          startDate: "",
          endDate: null,
          mrn: patient.mrn,
          eocn: nextEocId,
          referralSource: "",
          additionalsResults: {},
          additionalsReportResults: {},
          maritalStatus: patient.maritalStatus
            ? {
                value: patient.maritalStatus.id,
                label: patient.maritalStatus.name
              }
            : null,
          race: patient.race
            ? {
                value: patient.race.id,
                label: patient.race.name
              }
            : null,
          ethnicity: patient.ethnicity
            ? {
                value: patient.ethnicity.id,
                label: patient.ethnicity.name
              }
            : null,
          language: patient.language
            ? {
                value: patient.language.id,
                label: patient.language.name
              }
            : null,
          occupation: patient.occupation,
          billType: patient.billType,
          generalNotes: patient.generalNotes,
          contactPreference: patient.contactPreference,
          placesOfService: []
        };
        if (patient.avatarId) {
          this.avatar = await this.downloadImage(patient.avatarId);
        }
      } else {
        this.form = {
          ...this.form,
          mrn: this.nextMrn.toString(),
          eocn: "A"
        };
      }

      if (this.eligibilityVerificationId) {
        const verification = await eligibilityVerificationServer.get(
          this.eligibilityVerificationId
        );
        this.form.firstName =
          this.form.firstName ?? verification.memberFirstName;
        this.form.lastName = this.form.lastName ?? verification.memberLastName;
        this.form.dateOfBirth =
          this.form.dateOfBirth ?? new Date(verification.memberDateOfBirth);
        const selfRelationShip = this.relationships.find(
          r => r.label.toLowerCase() == "self"
        );

        const insurance = await insuranceCompanyServer.get(
          verification.insurance.id
        );
        if (
          !this.form.insurances.some(
            u =>
              u.company.id == verification.insurance.id &&
              u.memberIdent == verification.memberId
          )
        ) {
          this.form.insurances.push({
            company: {
              ...insurance,
              data: insurance
            },
            plan: null,
            memberIdent: verification.memberId,
            groupNo: "",
            coverage: null,
            relationship: {
              id: selfRelationShip.value,
              name: selfRelationShip.label
            },
            insuredDob: null,
            insuredFirstName: "",
            insuredMiddleName: "",
            insuredLastName: "",
            insuredSsn: "",
            insuredPhone: "",
            insuredAddressLine1: "",
            insuredAddressLine2: "",
            insuredCity: "",
            insuredState: "",
            insuredZipcode: ""
          });
        }
      }
    },
    async downloadImage(imageId) {
      let result = "";
      try {
        result = await avatarServer.downloadUrl(imageId);
      } catch (e) {
        console.log(e);
      }

      return result;
    },
    downloadFullImage(imageId) {
      let url = "";
      try {
        const viewUrl = this.$router.resolve(
          `/view-original-avatar/${serverCore.getToken()}/${imageId}`
        );
        url = viewUrl.href;
      } catch (e) {
        console.log(e);
      }
      return url;
    },
    async initializeFormSubmitter() {
      this.ready = false;
      await this.setInitialValues();
      this.formAdditionalInfo = await this.getFormBuilderFormById(
        this.forms["eocAdditionalInfo"][0].id
      );
      let version = this.formAdditionalInfo.current;
      let values = {};
      if (this.eocEditId) {
        values = this.form.additionalsResults;
      }
      const client = {};
      const eoc = {};

      client.episodeOfCare = eoc || {};
      client.episodeOfCare.vitals = [];
      await this.initializeFormSubmitterForm({
        formId: this.formAdditionalInfo.id,
        formName: this.formAdditionalInfo.name,
        version: version,
        client: client,
        eoc: eoc,
        document: { results: values },
        showType: "form-submitter",
        selectedLocation: this.selectedLocation
      });
      this.ready = true;
    },
    showPictureTaker() {
      this.removedPicture = false;
      this.pictureTakerShown = true;
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia({
            video: {
              width: { min: 460, ideal: 460, max: 460 },
              height: { min: 250, ideal: 250, max: 250 }
            }
          })
          .then(stream => {
            this.stream = stream;
            this.$refs.video.srcObject = stream;
            this.$refs.video.play();
          });
      }
    },
    async savePicture(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$refs.canvas
        .getContext("2d")
        .drawImage(this.$refs.video, 0, 0, 460, 250);
      const controlValue = {
        picture: this.$refs.canvas.toDataURL("image/png"),
        date: formatDateTimeSql(this.getCurrentAdjustedDateTime())
      };
      const file = controlValue.picture;
      const blob = await resizeImage(file, 1920, 1920);
      this.fileChoosed = blob;
      this.cropImage = true;
      this.pictureTakerShown = false;
    },
    async removePicture() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this picture?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(() => {
          this.removedPicture = true;
          this.fileChoosed = null;
          this.avatar = null;
        });
    },
    stopAccessCamera() {
      this.stream.getTracks().forEach(track => {
        if (track.readyState == "live" && track.kind === "video") {
          track.stop();
        }
      });
    },
    async validateClientSubmit() {
      let withoutErrors = await this.validateFormSubmitterForm();

      this.avatarErrors = [];

      this.formErrors.firstName = [];
      if (!validateRequired(this.form.firstName)) {
        this.formErrors.firstName.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.lastName = [];
      if (!validateRequired(this.form.lastName)) {
        this.formErrors.lastName.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.dateOfBirth = [];
      if (!validateRequired(this.form.dateOfBirth)) {
        this.formErrors.dateOfBirth.push("This field is required");
        withoutErrors = false;
      }

      if (this.form.dateOfBirth && !validateDate(this.form.dateOfBirth)) {
        this.formErrors.dateOfBirth.push(
          "This field must have a valid date format"
        );
        withoutErrors = false;
      }

      this.formErrors.email = [];
      if (this.form.email && !validateEmail(this.form.email)) {
        this.formErrors.email.push("This field must have a valid email format");
        withoutErrors = false;
      }

      this.formErrors.phone = [];
      if (
        this.isDoseSpotActive &&
        (!validateRequired(this.form.phone) ||
          this.form.phone.trim().length <=
            this.activePhoneCountry.dialCode.length + 1)
      ) {
        this.formErrors.phone.push("This field is required");
        withoutErrors = false;
      }

      if (
        this.form.phone &&
        this.form.phone.trim().length >
          this.activePhoneCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.form.phone)
      ) {
        this.formErrors.phone.push("Invalid phone number");
        withoutErrors = false;
      }

      this.formErrors.landLineNumber = [];
      if (
        this.form.landLineNumber &&
        this.form.landLineNumber.trim().length >
          this.activeLandLineNumberCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.form.landLineNumber)
      ) {
        this.formErrors.landLineNumber.push("Invalid phone number");
        withoutErrors = false;
      }

      this.formErrors.ssn = [];
      if (
        this.form.ssn &&
        !validateSSN(this.form.ssn) &&
        this.hasCurrentUserPermissionAccess("patients", "ssn")
      ) {
        this.formErrors.ssn.push("This field must have a valid SSN format");
        withoutErrors = false;
      }

      this.formErrors.zipcode = [];
      if (this.form.zipcode && !validateZipcode(this.form.zipcode)) {
        this.formErrors.zipcode.push(
          "This field must have a valid Zipcode format"
        );
        withoutErrors = false;
      }

      this.formErrors.mrn = [];
      if (!validateRequired(this.form.mrn)) {
        this.formErrors.mrn.push("This field is required");
        withoutErrors = false;
      }

      if (this.systemSetting.saisystemsEnabled) {
        this.formErrors.gender = [];
        if (!validateRequired(this.form.gender)) {
          this.formErrors.gender.push("This field is required");
          withoutErrors = false;
        }
      }

      if (this.isDoseSpotActive || this.systemSetting.saisystemsEnabled || this.isEMAREnabled) {
        this.formErrors.gender = [];
        if (!validateRequired(this.form.gender)) {
          this.formErrors.gender.push("This field is required");
          withoutErrors = false;
        }

        this.formErrors.addressLine1 = [];
        if (!validateRequired(this.form.addressLine1)) {
          this.formErrors.addressLine1.push("This field is required");
          withoutErrors = false;
        }

        this.formErrors.city = [];
        if (!validateRequired(this.form.city)) {
          this.formErrors.city.push("This field is required");
          withoutErrors = false;
        }

        this.formErrors.state = [];
        if (!validateRequired(this.form.state)) {
          this.formErrors.state.push("This field is required");
          withoutErrors = false;
        }

        if (!validateRequired(this.form.zipcode)) {
          this.formErrors.zipcode.push("This field is required");
          withoutErrors = false;
        }

        if (!validateRequired(this.form.email)) {
          this.formErrors.email.push("This field is required");
          withoutErrors = false;
        }
        if (
          !validateRequired(this.form.phone) ||
            this.form.phone.trim().length <=
            this.activePhoneCountry.dialCode.length + 1
        ) {
            this.formErrors.phone.push("This field is required");
            withoutErrors = false;
        }
      }
      return withoutErrors;
    },
    async submitClient(modalEvent, closeModal = false) {
      this.setPatientPaymentMethods();
      modalEvent.preventDefault();
      const result = await this.validateClientSubmit();
      if (!result) {
        this.activeTab = 0;
        setTimeout(() => {
          let firstErrorElement = document.querySelector(".is-invalid");
          let topPos = 0;
          while (!hasClass(firstErrorElement, "client-form-container")) {
            topPos += firstErrorElement.offsetTop;
            firstErrorElement = firstErrorElement.offsetParent;
          }
          document.querySelector(
            ".client-form-container .tab-content"
          ).scrollTop = topPos - 60;
        }, 200);

        return;
      }
      let additionalsReportResults = { ...this.additionalsReportResults };
      for (
        let index = 0;
        index < Object.keys(this.additionalInfoMetadata).length;
        index++
      ) {
        const cId = Object.keys(this.additionalInfoMetadata)[index];
        const jsonElement = getElementFromId(
          { ...this.formAdditionalInfo.current.content, id: randomId() },
          cId
        );
        if (jsonElement) {
          const componentData = getElementComponentData(
            jsonElement.elType,
            jsonElement.version
          );
          additionalsReportResults[
            this.additionalInfoMetadata[cId].label
          ] = componentData.getValueReport
            ? componentData.getValueReport(this.additionalInfoValues[cId])
            : this.additionalInfoValues[cId];
        }
      }
      const data = {
        patientId: this.patientId,
        locationId: this.locationId,
        eligibilityVerificationId: this.eligibilityVerificationId,
        eocn: this.form.eocn,
        referralSource: this.form.referralSource,
        startDate: this.form.startDate
          ? formatDateTimeSql(this.form.startDate)
          : null,
        endDate: this.form.endDate
          ? formatDateTimeSql(this.form.endDate)
          : null,
        insurances: this.form.insurances.map(insurance => ({
          id: insurance.id,
          companyId: insurance.company ? insurance.company.id : null,
          planId: insurance.plan ? insurance.plan.id : null,
          memberIdent: insurance.memberIdent,
          groupNo: insurance.groupNo,
          insuranceCoverage: insurance.coverage,
          patientRelationshipId: insurance.relationship
            ? insurance.relationship.id
            : null,
          patientRelationshipOther: insurance.relationshipOther,
          insuredFirstName: insurance.insuredFirstName,
          insuredMiddleName: insurance.insuredMiddleName,
          insuredLastName: insurance.insuredLastName,
          insuredDob: insurance.insuredDob,
          insuredSsn: insurance.insuredSsn,
          insuredPhone: insurance.insuredPhone,
          insuredAddressLine1: insurance.insuredAddressLine1,
          insuredAddressLine2: insurance.insuredAddressLine2,
          insuredCity: insurance.insuredCity,
          insuredStateId: insurance.insuredState
            ? insurance.insuredState.id
            : null,
          insuredGenderId: insurance.insuredGender
            ? insurance.insuredGender.id
            : null,
          insuredZipcode: insurance.insuredZipcode,
          payerTypeId: insurance.payerType ? insurance.payerType.id : null,
          copay: isNaN(parseFloat(insurance.copay))
            ? null
            : parseFloat(insurance.copay),
          deductibleCoInsurance: isNaN(
            parseFloat(insurance.deductibleCoInsurance)
          )
            ? null
            : parseFloat(insurance.deductibleCoInsurance),
          effectiveDate: insurance.effectiveDate,
          terminationDate: insurance.terminationDate,
          paidThroughDate: insurance.paidThroughDate,
          notes: insurance.notes,
          gracePeriod: insurance.gracePeriod
            ? insurance.gracePeriod.value
            : false,
          insuranceCardFrontBase64: insurance.insuranceCardFrontBase64,
          insuranceCardBackBase64: insurance.insuranceCardBackBase64,
          deleteInsuranceFrontCard: insurance.deleteInsuranceCardFront,
          deleteInsuranceBackCard: insurance.deleteInsuranceCardBack
        })),
        contacts: this.form.contacts.map(contact => ({
          id: contact.id,
          name: contact.name,
          relationshipId: contact.relationship ? contact.relationship.id : null,
          relationshipOther: contact.relationshipOther,
          phone: contact.phone,
          email: contact.email,
          address: contact.address,
          zipCode: contact.zipCode,
          city: contact.city,
          stateId: contact.state ? contact.state.id : null
        })),
        guarantors: this.form.guarantors.map(guarantor => ({
          id: guarantor.id,
          firstName: guarantor.firstName,
          middleName: guarantor.middleName,
          lastName: guarantor.lastName,
          dateOfBirth: guarantor.dateOfBirth ? guarantor.dateOfBirth : null,
          relationshipId: guarantor.relationship
            ? guarantor.relationship.id
            : null,
          relationshipOther: guarantor.relationshipOther,
          ssn: guarantor.ssn
            ? guarantor.ssn.includes("*")
              ? guarantor.ssn
              : guarantor.ssn.replace(/[^0-9]+/g, "")
            : null,
          genderId: guarantor.gender ? guarantor.gender.id : null,
          phone: guarantor.phone ? guarantor.phone : null,
          fax: guarantor.fax ? guarantor.fax : null,
          email: guarantor.email ? guarantor.email : null,
          address: guarantor.address ? guarantor.address : null,
          zipCode: guarantor.zipCode,
          city: guarantor.city,
          stateId: guarantor.state ? guarantor.state.id : null,
          patientId: this.patientId
        })),
        allergies: this.form.allergies.map(allergy => ({
          id: allergy.id,
          allergyTypeId: allergy.allergyType ? allergy.allergyType.id : null,
          allergenId: allergy.allergen ? allergy.allergen.id : null,
          reactionId: allergy.reaction ? allergy.reaction.id : null,
          severityId: allergy.severity ? allergy.severity.id : null,
          otherAllergen: allergy.otherAllergen,
          otherReaction: allergy.otherReaction
        })),
        caseLoads: this.form.caseLoads.map(caseLoad => ({
          id: caseLoad.id,
          userId: caseLoad.user ? caseLoad.user.id : null,
          caseRoleId: caseLoad.caseRole ? caseLoad.caseRole.id : null
        })),
        patient: {
          mrn: this.form.mrn,
          hasDefaultMrn: this.nextMrn == this.form.mrn,
          firstName: this.form.firstName,
          middleName: this.form.middleName,
          preferredName: this.form.preferredName,
          lastName: this.form.lastName,
          dateOfBirth: this.form.dateOfBirth,
          email: this.form.email,
          phone: this.form.phone,
          landLineNumber: this.form.landLineNumber,
          removeAvatar: this.removedPicture,
          avatarContent: this.fileChoosed && this.avatar ? this.avatar : null,
          originalAvatarContent: this.fileChoosed
            ? await fileToBase64(this.fileChoosed)
            : null,
          ssn: this.form.ssn.includes("*")
            ? this.form.ssn
            : this.form.ssn.replace(/[^0-9]+/g, ""),
          city: this.form.city,
          zipcode: this.form.zipcode,
          addressLine1: this.form.addressLine1,
          addressLine2: this.form.addressLine2,
          genderId: this.form.gender ? this.form.gender.value : null,
          pronounId: this.form.pronoun ? this.form.pronoun.value : null,
          stateId: this.form.state ? this.form.state.value : null,
          maritalStatusId: this.form.maritalStatus
            ? this.form.maritalStatus.value
            : null,
          raceId: this.form.race ? this.form.race.value : null,
          ethnicityId: this.form.ethnicity ? this.form.ethnicity.value : null,
          languageId: this.form.language ? this.form.language.value : null,
          occupation: this.form.occupation,
          billType:
            this.form.billType == 0
              ? 0
              : this.form.billType == 1 && !this.insuranceItems.length
              ? 0
              : 1,
          contactPreference: this.form.contactPreference,
          generalNotes: this.form.generalNotes
        },
        placeOfServiceIds: this.form.placesOfService.map(place => place.value),
        grantAccesses: this.portalAccesses
          .filter(item => item.status === "Enabled")
          .map(item => ({ patientId: this.patientId, email: item.email })),
        revokeAccesses: this.portalAccesses
          .filter(item => item.status === "Disabled")
          .map(item => ({ patientId: this.clientId, email: item.email })),
        additionalsFormId: this.formAdditionalInfo
          ? this.formAdditionalInfo.id
          : null,
        additionalsVersionId: this.formAdditionalInfo
          ? this.formAdditionalInfo.current
            ? this.formAdditionalInfo.current.id
            : null
          : null,
        additionalsResults: this.additionalInfoValues,
        additionalsReportResults: additionalsReportResults,
        paymentMethods:
          !this.patientId || this.paymentMethodsModified
            ? this.form.paymentMethods && this.form.paymentMethods.length > 0
              ? this.form.paymentMethods.map(card => {
                  return {
                    id: card.id,
                    nameOnCard: card.nameOnCard,
                    cardNumber: card.cardNumber,
                    expirationDate: card.id
                      ? card.expDate
                      : card.expMonth + card.expYear.slice(-2),
                    zipCode: card.zipCode,
                    stateId: card.stateId,
                    city: card.city,
                    street1: card.street1,
                    comments: card.comments
                  };
                })
              : []
            : null
      };
      let noErrors = true;
      let eocResponse = {};
      if (!this.eocEditId) {
        try {
          eocResponse = await eocServer.create(data);
          this.eocEditId = eocResponse.id;
          this.patientId = eocResponse.patientId;

          this.form.mrn = eocResponse.patient.mrn;
          this.$dialog.alert(
            {
              title: `Patient created with MR# ${eocResponse.patient.mrn}`
            },
            {
              view: "info"
            }
          );
        } catch (e) {
          noErrors = false;
          if (e.response.data.errorCode == "mrnEocAlreadyExists") {
            this.showError({
              message:
                "A patient with this MR# and this Mrn Suffix already exists"
            });
          }
          if (e.response.data.errorCode == "ssnAlreadyTaken") {
            this.showError({
              message:
                "A patient with this SSN already exists"
            });
          }
          if (e.response.data.errorCode == "emailAlreadyTaken") {
            this.showError({
              message:
                "A patient with this email already exists"
            });
          }
        }
      } else {
        try {
          eocResponse = await eocServer.update(this.eocEditId, data);
        } catch (e) {
          noErrors = false;
          if (e.response.data.errorCode == "mrnEocAlreadyExists") {
            this.showError({
              message:
                "A patient with this Mr# and this Mrn Suffix already exists"
            });
          }
          if (e.response.data.errorCode == "ssnAlreadyTaken") {
            this.showError({
              message:
                "A patient with this SSN already exists"
            });
          }
          if (e.response.data.errorCode == "emailAlreadyTaken") {
            this.showError({
              message:
                "A patient with this email already exists"
            });
          }
        }
      }

      if (noErrors) {
        this.clientSaved = true;
        this.showAlertSuccess();
        this.hasUnsavedChanges = false;
        await this.$refs.patientPaymentMethod.getAllPaymentMethods(
          this.patientId
        );
        if (closeModal) {
          this.$emit("onModify");
        } else {
          await this.$refs.portalAccess.fetchPortalAccesses();
          this.form.contacts = eocResponse.patient.contacts;
          this.form.guarantors = eocResponse.patient.guarantors;
          let insurances = [];
          for (let i = 0; i < eocResponse.patient.insurances.length; i++) {
            let insurance = eocResponse.patient.insurances[i];
            insurances.push({
              ...insurance,
              relationship: insurance.patientRelationship,
              coverage: insurance.insuranceCoverage,
              effectiveDateStart: insurance.effectiveDateFrom,
              effectiveDateEnd: insurance.effectiveDateTo,
              coInsurance: insurance.coInsurancePercent,
              gracePeriod: insurance.gracePeriod
                ? {
                    value: insurance.gracePeriod,
                    name: "Yes"
                  }
                : {
                    value: insurance.gracePeriod,
                    name: "No"
                  },
              insuranceCardFrontBase64: insurance.insuranceCardFrontId
                ? await this.downloadImage(insurance.insuranceCardFrontId)
                : null,
              insuranceCardBackBase64: insurance.insuranceCardBackId
                ? await this.downloadImage(insurance.insuranceCardBackId)
                : null,
              insuranceCardFrontUrl: insurance.insuranceCardFrontId
                ? await this.downloadFullImage(insurance.insuranceCardFrontId)
                : null,
              insuranceCardBackUrl: insurance.insuranceCardBackId
                ? await this.downloadFullImage(insurance.insuranceCardBackId)
                : null
            });
          }
          this.form.insurances = insurances;
        }
      }
    },

    async submitClientAndCloseTab(modalEvent) {
      await this.submitClient(modalEvent, true);
    },
    chooseFile() {
      this.removedPicture = false;
      this.$refs.fileUpload.click();
    },
    validateCropFile(file) {
      let withoutErrors = true;

      const fileSize = (file.size / 1024 / 1024).toFixed(4);

      this.avatarErrors = [];
      if (fileSize > 20) {
        this.avatarErrors.push("Image max size 20 mb");
        withoutErrors = false;
      }

      if (!file.type.includes("image/")) {
        this.avatarErrors.push("Only image file supported");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async cropFile() {
      const file = this.$refs.fileUpload.files[0];
      const result = this.validateCropFile(file);
      if (result) {
        const blobUrl = URL.createObjectURL(file);
        const blob = await resizeImage(blobUrl, 1920, 1920);
        this.fileChoosed = blob;
        this.cropImage = true;
      }
    },
    revertCrop() {
      this.fileChoosed = null;
    },
    saveCroppedImage(croppedBase64) {
      this.avatar = croppedBase64;
    },
    addAllergy() {
      this.formAllergy = null;
      this.allergyModalShow = true;
    },
    async submitAllergy(data) {
      if (typeof data.itemIndex == "number") {
        this.form.allergies.splice(data.itemIndex, 1, data);
      } else {
        this.form.allergies.push(data);
      }
      this.allergyModalShow = false;
    },
    addCaseLoad() {
      this.formCaseLoadId = null;
      this.formCaseLoad = {
        user: null,
        caseRole: null
      };
      this.formCaseLoadErrors = {
        user: [],
        caseRole: []
      };
      this.caseLoadModalShow = true;
    },
    validateCaseLoadSubmit() {
      let withoutErrors = true;

      this.formCaseLoadErrors.user = [];
      if (!validateRequired(this.formCaseLoad.user)) {
        this.formCaseLoadErrors.user.push("This field is required");
        withoutErrors = false;
      }
      this.formCaseLoadErrors.caseRole = [];
      if (!validateRequired(this.formCaseLoad.caseRole)) {
        this.formCaseLoadErrors.caseRole.push("This field is required");
        withoutErrors = false;
      }
      return withoutErrors;
    },
    insertPrimaryProvider(newPrimaryProvider) {
      let foundPrimaryProvider = false;
      const newCaseLoads = [];
      for (let index = 0; index < this.form.caseLoads.length; index++) {
        const caseLoad = this.form.caseLoads[index];
        if (caseLoad.caseRole && caseLoad.caseRole.type == "PrimaryProvider") {
          foundPrimaryProvider = true;
          if (newPrimaryProvider) caseLoad.user = newPrimaryProvider;
          else continue;
        }
        newCaseLoads.push(caseLoad);
      }
      this.form.caseLoads = newCaseLoads;
      return foundPrimaryProvider;
    },
    async submitCaseLoad(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateCaseLoadSubmit();
      if (result) {
        let foundPrimaryProvider = false;
        if (this.formCaseLoad.caseRole.data.type == "PrimaryProvider") {
          this.form.primaryProvider = this.formCaseLoad.user;
          foundPrimaryProvider = this.insertPrimaryProvider({
            id: this.formCaseLoad.user.value,
            firstName: this.formCaseLoad.user.data.firstName,
            lastName: this.formCaseLoad.user.data.lastName,
            middleName: this.formCaseLoad.user.data.middleName
          });
        }
        if (!foundPrimaryProvider) {
          const caseLoadData = {
            id: this.formCaseLoad.id,
            user: this.formCaseLoad.user
              ? {
                  id: this.formCaseLoad.user.value,
                  firstName: this.formCaseLoad.user.data.firstName,
                  lastName: this.formCaseLoad.user.data.lastName,
                  middleName: this.formCaseLoad.user.data.middleName
                }
              : null,
            caseRole: this.formCaseLoad.caseRole
              ? {
                  id: this.formCaseLoad.caseRole.value,
                  name: this.formCaseLoad.caseRole.label,
                  type: this.formCaseLoad.caseRole.data.type
                }
              : null
          };
          if (typeof this.formCaseLoad.itemIndex == "number") {
            this.form.caseLoads.splice(
              this.formCaseLoad.itemIndex,
              1,
              caseLoadData
            );
          } else {
            this.form.caseLoads.push(caseLoadData);
          }
        }

        this.caseLoadModalShow = false;
      }
    },
    removeCurrentTab() {
      this.$emit("remove-current-tab");
    },
    removeEOC() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this episode of care?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          await eocServer.delete(this.eocEditId);
          this.dispatchListener({ listener: "fetchEoc", param: "all" });

          this.showAlertSuccess();
          this.removeCurrentTab();
          this.$emit("onModify");
        })
        .catch(function() {});
    },
    async getUsers() {
      const users = await userServer.getMinimalUsers();
      this.users = users.map(user => ({
        value: user.id,
        label: this.formatUser(user),
        data: user
      }));
    },
    addInsurance() {
      this.formInsurance = null;
      this.insuranceModalShow = true;
    },
    editInsurance(record) {
      this.formInsurance = {
        itemIndex: record.itemIndex,
        ...record.data,
        insuredPhone: record.data.insuredPhone ? record.data.insuredPhone : ""
      };

      this.insuranceModalShow = true;
    },
    deleteInsurance(record) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          this.form.insurances.splice(record.itemIndex, 1);
        })
        .catch(function() {});
    },
    submitInsurance(insuranceData) {
      if (typeof insuranceData.itemIndex == "number") {
        this.form.insurances.splice(insuranceData.itemIndex, 1, insuranceData);
      } else {
        this.form.insurances.push(insuranceData);
      }
      this.form = { ...this.form };
      this.insuranceModalShow = false;
    },
    editAllergy(record) {
      this.formAllergy = {
        itemIndex: record.itemIndex,
        ...record.data
      };
      this.allergyModalShow = true;
    },
    onModifyAddAllergy() {
      this.allergyModalShow = false;
    },
    deleteAllergy(record) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          this.form.allergies.splice(record.itemIndex, 1);
        })
        .catch(function() {});
    },
    editCaseLoad(record) {
      this.formCaseLoadId = record.id;
      this.formCaseLoad = {
        itemIndex: record.itemIndex,
        ...record.data,
        user: record.data.user
          ? {
              value: record.data.user.id,
              label: this.formatUser(record.data.user),
              data: record.data.user
            }
          : null,
        caseRole: record.data.caseRole
          ? {
              value: record.data.caseRole.id,
              label: record.data.caseRole.name,
              data: record.data.caseRole
            }
          : null
      };
      this.formCaseLoadErrors = {
        user: [],
        caseRole: []
      };
      this.caseLoadModalShow = true;
    },
    deleteCaseLoad(record) {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this record?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(async () => {
          if (record.data.caseRole.type == "PrimaryProvider") {
            this.primaryProviderForm = null;
          } else {
            this.form.caseLoads.splice(record.itemIndex, 1);
          }
        })
        .catch(function() {});
    },
    cancelAddEdit() {
      if (this.hasUnsavedChanges || this.additionalInfoHasUnsavedChanges) {
        this.$dialog
          .confirm(
            {
              title: "Do you want to save your changes?"
            },
            {
              view: "confirm-unsaved-changes"
            }
          )
          .then(async ({ data }) => {
            if (data.confirmValue) {
              await this.$refs.submitAndCloseButton.click();
            } else {
              this.$emit("onModify");
            }
          })
          .catch(function() {});
      } else {
        this.$emit("onModify");
      }
    },
    getPatientInfo() {
      return {
        firstName: this.form.firstName,
        middleName: this.form.middleName,
        preferredName: this.form.preferredName,
        lastName: this.form.lastName,
        dateOfBirth: this.form.dateOfBirth,
        email: this.form.email,
        phone: this.form.phone,
        landLineNumber: this.form.landLineNumber,
        ssn: this.form.ssn,
        gender: this.form.gender,
        pronoun: this.form.pronoun,
        address: this.form.addressLine1,
        city: this.form.city,
        state: this.form.state,
        zipCode: this.form.zipcode
      };
    },
    addPaymentMethod() {
      this.$refs.patientPaymentMethod.isNewCardVisible = true;
      this.paymentMethodsModified = true;
    },
    setPatientPaymentMethods() {
      this.form.paymentMethods = this.$refs.patientPaymentMethod.paymentMethods;
      this.paymentMethodsModified = true;
    }
  },
  computed: {
    ...mapGetters("layout", ["hasCurrentUserPermissionAccess"]),
    ...mapState("layout", {
      isDoseSpotActive: state => state.isDoseSpotActive,
      selectedLocation: state => state.selectedLocation,
      systemSetting: state => state.systemSetting,
      isEMAREnabled: state => state.systemSetting?.emarEnabled
    }),
    ...mapState("client", {
      genders: state =>
        state.genders.map(gender => ({
          value: gender.id,
          label: gender.name
        })),
      pronouns: state =>
        state.pronouns.map(pronoun => ({
          value: pronoun.id,
          label: pronoun.name
        })),
      states: state =>
        state.states.map(state => ({
          value: state.id,
          label: state.name
        })),
      caseRoles: state =>
        state.caseRoles.map(caseRole => ({
          value: caseRole.id,
          label: caseRole.name,
          data: caseRole
        })),
      maritalStatuses: state =>
        state.maritalStatuses.map(maritalStatus => ({
          value: maritalStatus.id,
          label: maritalStatus.name
        })),
      races: state =>
        state.races.map(race => ({
          value: race.id,
          label: race.name
        })),
      ethnicities: state =>
        state.ethnicities.map(ethnicity => ({
          value: ethnicity.id,
          label: ethnicity.name
        })),
      languages: state =>
        state.languages.map(language => ({
          value: language.id,
          label: language.name
        })),
      relationships: state =>
        state.relationships.map(relationship => ({
          value: relationship.id,
          label: relationship.name
        })),
      placesOfService: state =>
        state.placesOfService.map(place => ({
          value: place.id,
          label: place.code + "-" + place.name,
          data: place
        }))
    }),
    ...mapState("layout", {
      currentUser: state => state.currentUser
    }),
    ...mapState("formBuilder", {
      forms: state => state.list
    }),
    ...mapState("formSubmitter", {
      json: state => state.form.json
    }),
    ...mapState("formSubmitter", {
      additionalInfoValues: state => state.form.values,
      additionalInfoHasUnsavedChanges: state => state.form.hasUnsavedChanges,
      additionalInfoMetadata: state => state.form.metadata
    }),
    ...mapGetters("formBuilder", ["getFormBuilderFormById"]),
    patientItem() {
      return {
        name: `${this.form.firstName ?? ""} ${this.form.middleName ?? ""} ${
          this.form.preferredName ? '"' + this.form.preferredName + '"' : ""
        } ${this.form.lastName ?? ""}`,
        email: this.form.email,
        relationship: "Patient",
        status: "Disabled"
      };
    },
    insuranceItems() {
      return this.form.insurances.map((item, itemIndex) => {
        let insuredAddressComponents = [];
        if (item.insuredAddressLine1 || item.insuredAddressLine2)
          insuredAddressComponents.push(
            `${item.insuredAddressLine1}${
              item.insuredAddressLine2 ? " " + item.insuredAddressLine2 : ""
            }`
          );
        if (item.insuredCity)
          insuredAddressComponents.push(`${item.insuredCity}`);
        if (item.insuredState)
          insuredAddressComponents.push(`${item.insuredState.name}`);
        if (item.insuredZipcode)
          insuredAddressComponents.push(`${item.insuredZipcode}`);
        let insuredAddressData = insuredAddressComponents.join(", ");
        return {
          itemIndex: itemIndex,
          data: item,
          title:
            this.insuranceCoverages[item.coverage] +
            (item.company ? " | " : "") +
            (item.company ? item.company.name : ""),
          extraData: [
            [
              `ID: ${item.memberIdent}`,
              `Plan: ${item.plan ? item.plan.name : ""}`,
              `Group: ${item.groupNo}`,
              `Relationship: ${
                item.relationship ? item.relationship.name : ""
              }`,
              ...(item.relationship && item.relationship.name == "Self"
                ? []
                : [
                    `Insured Name: ${item.insuredFirstName} ${
                      item.insuredMiddleName ? item.insuredMiddleName : ""
                    } ${item.insuredLastName ? item.insuredLastName : ""}`,
                    ...(item.insuredSsn
                      ? [`Insured SSN: ${item.insuredSsn}`]
                      : []),
                    ...(item.insuredDob
                      ? [`Insured DOB: ${formatDateOnly(item.insuredDob)}`]
                      : []),
                    ...(item.insuredAddressData
                      ? [`Insured Address: ${insuredAddressData}`]
                      : [])
                  ])
            ],
            [
              `Phone#: ${item.company ? item.company.phoneNumber : ""}`,
              `Email: ${item.company ? item.company.email : ""}`,
              `Fax: ${item.company ? item.company.fax : ""}`
            ]
          ]
        };
      });
    },
    allergyItems() {
      return this.form.allergies.map((item, itemIndex) => ({
        itemIndex,
        data: item,
        title: item.allergyType.name,
        extraData: [
          [
            `Allergen: ${
              item.allergen
                ? item.allergen.name.toLowerCase() == "other"
                  ? item.otherAllergen
                  : item.allergen.name
                : ""
            }`,
            `Reaction: ${
              item.reaction
                ? item.reaction.name.toLowerCase() == "other"
                  ? item.otherReaction
                  : item.reaction.name
                : ""
            }`,
            `Severity: ${item.severity ? item.severity.name : ""}`
          ]
        ]
      }));
    },
    caseLoadItems() {
      const caseLoads = this.form.caseLoads.map((item, itemIndex) => ({
        itemIndex,
        data: item,
        title: this.formatUser(item.user),
        extraData: [[`Case Role: ${item.caseRole ? item.caseRole.name : ""}`]]
      }));
      return caseLoads;
    },
    primaryProviderForm: {
      get() {
        return this.form.primaryProvider;
      },
      set(newValue) {
        this.form.primaryProvider = newValue;
        const newUserCaseLoad = newValue
          ? {
              ...newValue.data,
              id: newValue.value,
              name: newValue.label
            }
          : null;
        const foundPrimaryProvider = this.insertPrimaryProvider(
          newUserCaseLoad
        );
        if (!foundPrimaryProvider && newUserCaseLoad) {
          const primaryProviderCaseRole = this.caseRoles.find(
            cR => cR.data.type == "PrimaryProvider"
          );
          const caseLoadData = {
            user: newUserCaseLoad,
            caseRole: primaryProviderCaseRole.data
          };
          this.form.caseLoads.push(caseLoadData);
        }
      }
    },
    providerUsers() {
      return this.users.filter(u => u.data.providerInfo);
    },
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    activePhoneCountry() {
      return this.$refs.phoneInput.$refs.telInput.activeCountry;
    },
    activeLandLineNumberCountry() {
      return this.$refs.landPhoneInput.$refs.telInput.activeCountry;
    }
  },
  watch: {
    form: {
      handler() {
        if (this.clientSaved) {
          this.clientSaved = false;
          this.hasUnsavedChanges = false;
          return;
        }
        if (this.dataLoaded) {
          this.hasUnsavedChanges = true;
        }
      },
      deep: true
    },
    removedPicture: {
      handler() {
        if (this.dataLoaded) {
          this.hasUnsavedChanges = true;
        }
      }
    },
    fileChoosed: {
      handler() {
        if (this.dataLoaded) {
          this.hasUnsavedChanges = true;
        }
      }
    },
    portalAccesses: {
      handler() {
        if (this.dataLoaded) {
          this.hasUnsavedChanges = true;
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.client-form-container >>> .tab-content {
  height: calc(100vh - 315px);
  overflow-y: auto;
  overflow-x: hidden;
}

.client-form-container >>> .nav-tabs {
  background-color: #f5f8fc;
  border-bottom: none;
  padding: 0 15px;
}

.client-form-container >>> .nav-tabs .nav-link {
  color: #777;
  font-weight: bold;
  background: none;
  border: none;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-radius: 2px;
  padding: 0.75rem 1rem;
  margin-bottom: 0;
}

.client-form-container >>> .tab-content {
  padding: 1rem;
}

.section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 63px;
  padding: 1rem;
  margin-top: 15px;
  margin-bottom: 15px;
}

.section-body {
  min-height: 70px;
}
</style>
